<template>
	<span>
        <b-modal id='modalPopup'
                 ref='modalPopup'
                 :title='titel'
                 @ok='onclick'
                 @cancel='cancelclick'
				 ok-title='Ok' 
				 close-title='Cancel'
				 >
            <slot :data="data"></slot>
        </b-modal>
	</span>
</template>


<script>

export default {
  name: 'popup',
  props: ['titel','okclick','data-vv-scope'],
  data () {
		return {
			data : null,
			srcdata: null,
			collection: [],
			isnew: false,
			err: null,
			validator: null
		}
	  },
  methods: {
		onclick: function(e) {
			this.validator.validateAll(this.dataVvScope);
		    if (!this.err.any(this.dataVvScope))
		    {
	    		this.$emit('okclick');
		        this.updateCollection();
		        this.close();  
		    }
		    else
		    {
		    	e.cancel();
		    }
		},
		cancelclick: function(e)
		{
			debugger;
			this.err.clear(this.dataVvScope);
		},
		show: function(data, collection, validator, errors) {
			this.err = errors;
			this.validator = validator;
			this.err.clear(this.dataVvScope);
			// Data is een deep-copy van oorspronkelijke record. Deze ga je editten zodat de oorspronkelijke data ongewijzigd blijft voor het geval van cancel.
			this.data = JSON.parse(JSON.stringify(data));
			// Srcdata is het oorspronkelijke record
			this.srcdata = data;

			this.isnew = collection.indexOf(data) == -1;
			this.collection = collection;
			this.$refs.modalPopup.show();
			
		},
		close: function(e) {
			this.$refs.modalPopup.hide();
		},
		getData: function() {
			return this.data;
		},
		updateCollection: function() {
			if (this.isnew)
	        {
	          // Add
	          this.collection.push(this.data);
	        } else
	        {
	          // Edit
	          var index = this.collection.indexOf(this.srcdata);
	          this.collection.splice(index, 1, JSON.parse(JSON.stringify(this.data)));
	        }
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// popup.vue?73d746e3